import React, { useEffect, useState } from "react";
import Inner_Footer_Text_Component from "../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { getAllPrivacyAgreement } from "../../utils/apis/content/content";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Privacy = () => {
  const navigate = useNavigate();

  const [privacyAgreement, setPrivacyAgreement] = useState("");
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const getLearnMore = async () => {
    const res = await getAllPrivacyAgreement();
    if (res?.success) {
      setPrivacyAgreement(res.data);
    }
  };

  useEffect(() => {
    getLearnMore();
  }, []);
  return (
    <section className="Privacy About_Profile">
      <div className="heading_div">
        <div className="row">
          <div className="col-8">
            <p className="info_page_title">Privacy Agreement</p>
          </div>
          <div className="col-4 text-end">
            <FontAwesomeIcon
              className="colpa-close"
              icon={faXmark}
              onClick={() => navigate(-1)}
            />
          </div>
        </div>
      </div>

      <div className="info_div">
        <p className="info_text">
          {htmlToReactParser.parse(privacyAgreement?.name)}
        </p>
      </div>

      <div className="footer_div">
        <Inner_Footer_Text_Component />
      </div>
    </section>
  );
};

export default Privacy;
